$.fn.overLoading = function(options) {
	var settings = $.extend(true, {
		$box: $([]),
		items: '',
		url: '',
		data: '',
		beforeAppend: $.noop
	}, options);

	this.each(function() {
		var $loaderBox = $(this),
			overLoadFlag = true,
			loaderTimer,
			overLoadPost = function() {
				var data = settings.data ? `${settings.data()}&countNews=${$(settings.items).length}` : {
					countNews: $(settings.items).length
				};

				overLoadFlag = false;
				$.ajax({
					url: settings.url,
					type: 'GET',
					dataType: 'json',
					data: data,
					success: function(json) {
						if (json.hasNewData === 'false') $loaderBox.addClass('hide');
						else $loaderBox.removeClass('hide');
						var $response = $(json.html);
						settings.beforeAppend($response);
						settings.$box.append($response);
						overLoadFlag = true;
					}
				});
			};

		settings.$box.data('loader', $loaderBox);
		app.checkLoader = function() {
			if ($.inViewport($loaderBox) && overLoadFlag) {
				clearTimeout(loaderTimer);
				loaderTimer = setTimeout(overLoadPost, 100);
			}
		};

		app.checkLoader();
		app.dom.$window.scroll(app.checkLoader);
	});
};